import React, { useContext } from 'react';
import { BetslipContext } from '../../data/betslip/BetslipConf';
import BetslipButtons from './BetslipButtons';
import EventCoupon from './EventCoupon';
import PotentialWinBox from './PotentialWinBox';
import SystemTuples from './SystemTuples';
import EventCouponWh from './betslip-components-wh/EventCouponWh';
import { getConfiguration } from '../../data/utils';

function SystemBets(props) {
	const betslipContext = useContext(BetslipContext);
	const conf = getConfiguration();
	let betslipData = betslipContext.getBetslipData();
	const couponKey = props.couponKey;
    const coupon = betslipData.coupons[couponKey];
    const showable = props.showable;
    const container = "systembets";
    const reactKeyPWB = 'key-potential-win-box-coupon-' + couponKey + '-container-' + container;
    const reactKeyButtons = 'key-betslip-buttons-' + couponKey + '-container-' + container;
    const reactKeyTuples = 'key-tuples-container' + couponKey + '-container-' + container;
    let selections = coupon.selections;

    return <div className={"tab-pane fade bordato-widget" + (showable? ' show active' : '')} id={"container-" + container + "-coupon-" + couponKey} role="tabpanel">
            <div className="carrello-scrollable">
                <div className="lista-eventi-schedina carrello-desktop_container-elementi">
                    {selections.map(function(selection) {
                        let reactKey = "key-bet-event-coupon-" + couponKey + "-container-" + container + "-pal-" + selection.pal + "-avv-" + selection.avv;
                        return <React.Fragment key={reactKey}>
                        {
                        	conf.iwh?
		            		<EventCouponWh selection={selection} couponKey={couponKey} container={container} />
		            		:      		
							<EventCoupon selection={selection} couponKey={couponKey} container={container} />	   
                        }
                        </React.Fragment>      
                    })}
                    <SystemTuples  container={container} couponKey={couponKey} key={reactKeyTuples} />
                </div>
            </div>
            <div className="carrello-fixed">
                <PotentialWinBox container={container} couponKey={couponKey} key={reactKeyPWB} />
                <BetslipButtons container={container} couponKey={couponKey} key={reactKeyButtons} />
            </div>
   </div>

}

export default SystemBets;